import React from 'react';
import { Link } from 'react-router-dom';
import { UIHeading2, UIHeading3, useDeviceType } from '@cian/ui-kit';

import { CatImage } from './components/CatImage';
import * as s from './NothingFound.css';

export interface INothingFound {
  pathname?: string;
  showResetFiltersLink?: boolean;
  hasDescription?: boolean;
}

/** Заглушка Ничего не найдено */
export const NothingFound = ({
  pathname = '/magazine/',
  showResetFiltersLink = false,
  hasDescription = true,
}: INothingFound) => {
  const deviceType = useDeviceType();
  const isPhone = () => deviceType === 'phone';

  return (
    <div className={s['wrapper']}>
      <Link to={pathname}>
        <CatImage />
      </Link>

      <div className={s['title']}>
        {isPhone() ? (
          <UIHeading3 as={'h2'}>Ничего не найдено</UIHeading3>
        ) : (
          <UIHeading2 as={'h2'}>Ничего не найдено</UIHeading2>
        )}
      </div>

      {hasDescription && (
        <div className={s['description']}>
          Попробуйте поменять запрос
          <br />и начать поиск заново
        </div>
      )}

      {showResetFiltersLink && (
        <div className={s['reset']}>
          <Link to={pathname}>Сбросить фильтры</Link>
        </div>
      )}
    </div>
  );
};
